<div class="view area">
  <span id="anchor"></span>

  <!-- Header: Sticky part -->
  <div class="header">
    <div class="header-title">
      <span [ngSwitch]="pagetype">

        <h1 *ngSwitchCase="'area'">
          <span>{{ 'area' | translate }}: </span>
          <span [attr.contenteditable]="authService.canUpdate('area')"
            (keydown.enter)="submitTitle($event, 'area', area)"
            (keydown.escape)="submitTitleCancel($event, area)"
            (blur)="submitTitle($event, 'area', area)">
            {{ area.name }}
          </span>
        </h1>

        <h1 *ngSwitchCase="'basicArea'">
          <span>{{ 'areatemplate' | translate }}: </span>
          <span [attr.contenteditable]="authService.canUpdate('basicarea')"
            (keydown.enter)="submitTitle($event, 'basicArea', basicArea)"
            (keydown.escape)="submitTitleCancel($event, basicArea)"
            (blur)="submitTitle($event, 'basicArea', basicArea)">
            {{ basicArea.name }}
          </span>
        </h1>

      </span>
      <span class="toolbar">

        <span [ngSwitch]="pagetype">
          <span *ngSwitchCase="'area'">
            <span class="a" (click)="goToLegacyBuilding()">{{ 'backtoarealist' | translate }}</span>
          </span>
          <span *ngSwitchCase="'basicArea'">
            <span class="a" (click)="goToLegacyBasicAreas()">{{ 'backtoareatemplateoverview' | translate }}</span>
          </span>
        </span>

        <ng-container *ngIf="pagetype === 'area'">
          <form>
            <mat-form-field>
              <mat-select 
                [(ngModel)]="selectedArea"
                (selectionChange)="goToSelectedArea()"
                [placeholder]="area.name"
                name="selectedArea">
                  <mat-optgroup *ngFor="let cluster of clusters" [label]="cluster.name">
                    <mat-option *ngFor="let item of cluster.areas" [value]="item">
                      {{ item.name }}
                    </mat-option>
                  </mat-optgroup>
              </mat-select>
            </mat-form-field>
          </form>
        </ng-container>

        <form>
          <mat-form-field>
            <mat-select [formControl]="areaFilterForm">
              <mat-option [value]="'all'">
                {{ 'showRequirement' | translate: 'plural' }}
              </mat-option>
              <ng-container *ngFor="let module of requirements">
                <mat-option *ngIf="moduleContainsRequirements(module)" [value]="module._id">
                  {{ 'showOnly' | translate }} {{ module.name }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </form>
      </span>
    </div>

    <!-- Header: Content area -->
    <div class="header-content">
      <span [ngSwitch]="pagetype">
        <sg2-area-details-properties *ngSwitchCase="'area'"></sg2-area-details-properties>
        <sg2-basic-area-details-properties *ngSwitchCase="'basicArea'"></sg2-basic-area-details-properties>
      </span>
    </div>
  </div>

  <!-- View -->
  <div class="view-content">

    <!-- Requirement -->
    <div [id]="module._id" class="requirement" *ngFor="let module of requirements">
      <mat-card *ngIf="(areaFilterForm.value === 'all' || areaFilterForm.value === module._id) && moduleContainsRequirements(module)">

        <!-- Header -->
        <mat-card-header>
          <span class="title">
            <h3>{{ module.name }}</h3>
          </span>
          <span class="toolbar">
            <!-- <sg2-module-options [module]="module" [options]="['assignTo', 'setStatus']"></sg2-module-options> -->
          </span>
        </mat-card-header>
        <hr>

        <!-- Content -->
        <mat-card-content>
          <div [id]="submodule._id" class="sub-content submodule" *ngFor="let submodule of module.submodules">
            <div fxLayout="row">
              <h4 fxFlex="50">{{ submodule.name }}</h4>
              <span class="toolbar" fxFlex="50">
                <button mat-flat-button
                  *ngIf="pagetype === 'area' && authService.canCreate('element')" 
                  color="primary" 
                  (click)="addRequirement(submodule.moduleId, submodule._id)">
                  {{ 'addSpecification' | translate }}
                </button>
              </span>
            </div>
            <table mat-table class="table-fixed table-status" 
              *ngIf="submodule.requirements?.length; else noRequirements;" [dataSource]="submodule.requirements">

              <!-- Icon -->
              <ng-container matColumnDef="icon">
                <th mat-header-cell *matHeaderCellDef>{{ 'type' | translate }}</th>
                <td mat-cell *matCellDef="let element">

                  <span *ngIf="element.projectLevel === 4 else iconArea">
                    <mat-icon>
                      select_all
                    </mat-icon>
                    <span class="mask basic-area-mask"
                      [matTooltip]="'areatemplatevalue' | translate"
                      matTooltipPosition="above"></span>
                  </span>

                  <ng-template #iconArea>
                    <mat-icon *ngIf="!element.basicAreaElementId else iconCustomArea"
                      [matTooltip]="'areaValueUnique' | translate"
                      matTooltipPosition="above">
                      crop_din
                    </mat-icon>
                  </ng-template>

                  <ng-template #iconCustomArea>
                    <mat-icon
                      [matTooltip]="'templateValueEdited' | translate"
                      matTooltipPosition="above">
                      flip_to_front
                    </mat-icon>
                  </ng-template>

                </td>
              </ng-container>

              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef>{{ 'code' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.code }}</td>
              </ng-container>

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>{{ 'requirement' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <span class="text-ellipsis-2">{{ element.name }}</span>
                </td>
              </ng-container>

              <!-- @todo Add readonly option to element value component -->
              <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef>{{ 'value' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <div *ngIf="!authService.canUpdate('element')">
                    {{ element.value | stripHtml }}
                  </div>
                  <div *ngIf="authService.canUpdate('element')">
                    <sg2-element-value [element]="element" view="area"></sg2-element-value>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="originalValue">
                <th mat-header-cell *matHeaderCellDef>{{ 'templatevalue' | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ (element.originalValue || '-') | stripHtml }} </td>
              </ng-container>

              <ng-container matColumnDef="unit">
                <th mat-header-cell *matHeaderCellDef>{{ 'unit' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <span [matTooltip]="( element.unit | unit: 'value': 'displayName' )" matTooltipPosition="above">
                    {{ element.unit | unit: 'value': 'short' }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="edited">
                <th mat-header-cell *matHeaderCellDef>{{ 'edited' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <span class="text-ellipsis-2" [matTooltip]="( element.updated | date: 'dd-MM-yyyy HH.mm' )" matTooltipPosition="above">
                    {{ element.updated | dateAgo }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>{{ 'status' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.status | status: '_id': 'displayName' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="assignedTo">
                <th mat-header-cell *matHeaderCellDef>{{ 'assignedto' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <sg2-user-icon
                    *ngIf="authService.canRead('element-assignment')"
                    [user]="element.assignedToUserId">
                  </sg2-user-icon> 
                </td>  
              </ng-container>

              <ng-container matColumnDef="options">
                <th mat-header-cell *matHeaderCellDef>{{ 'option' | translate: 'plural' }}</th>
                <td mat-cell *matCellDef="let element">
                  <sg2-element-options
                    *ngIf="authService.canRead('element-contextmenu')"
                    [element]="element">
                  </sg2-element-options>
                </td>  
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: tableColumns; let element"
                [id]="element._id"
                [ngClass]="{
                  'is-area': element.projectLevel === 5,
                  'is-basic-area': element.projectLevel === 4,
                  'muted': element.projectLevel === 4 && pagetype == 'area'
                }"
                [ngStyle]="{
                  'border-left': '5px solid ' +  ( element.status | status: '_id': 'color' )
                }">
              </tr>
            </table>
          </div>

          <ng-template #noRequirements>
            {{ 'noRequirement' | translate: 'plural' }}
          </ng-template>

        </mat-card-content>
      </mat-card>
    </div>

  </div>
</div>
